import React, { useEffect, useState } from 'react';
import { FaShareAlt, FaSearchPlus } from 'react-icons/fa';
import { products } from './ProductSection.js';
import './ProductDetails.css';
import { useParams } from 'react-router-dom';

const ProductDetails = ({ addToCart }) => {
    const [quantity, setQuantity] = useState(1);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [stock, setStock] = useState(null);

    const { id } = useParams();
    const product = products.find((prod) => prod.id == id);
    const [selectedImage, setSelectedImage] = useState(product.detailImages[0]);

    useEffect(() => {
        window.scrollTo(0, 0);
        setSelectedImage(product.detailImages[0]);
    }, [product]);

    // Fetch stock from backend

    useEffect(() => {
    const fetchStock = async () => {
        if (!product || !product.id) return;

        try {
            const response = await fetch(`https://neteroshealth.com/backend/api.php?action=getStock&id=${id}`);
            const data = await response.json();
            setStock(data.stock);
        } catch (error) {
            console.error("Failed to fetch stock", error);
            setStock(0);
        }
    };
    fetchStock();
}, [product]);


    const decreaseQuantity = () => {
        setQuantity(quantity > 1 ? quantity - 1 : 1);
    };

    const increaseQuantity = () => {
        setQuantity(quantity + 1);
    };

    const handleAddToCart = () => {
        const productToAdd = { ...product, quantity: product.isPack ? 1 : quantity };
        addToCart(productToAdd);
        window.scrollTo(0, 0);
    };

    const handleThumbnailClick = (imageSrc) => {
        setSelectedImage(imageSrc);
    };

    const handleZoomClick = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    return (
        <div className="product-details">
            {isModalOpen && (
                <div className="modal-overlay" onClick={closeModal}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <span className="close-modal" onClick={closeModal}>
                            &times;
                        </span>
                        <img src={selectedImage} alt="Zoomed Product" />
                    </div>
                </div>
            )}
            <div className="main-content">
                <div className="image-gallery">
                    <div className="thumbnail-list">
                        {product?.detailImages?.map((imageSrc, index) => (
                            <img
                                key={index}
                                src={imageSrc || '/placeholder.png'}
                                alt={`Thumbnail ${index + 1}`}
                                className={selectedImage === imageSrc ? 'active-thumbnail' : ''}
                                onClick={() => handleThumbnailClick(imageSrc)}
                            />
                        ))}
                    </div>
                    <div className="main-image" onClick={handleZoomClick}>
                        <img src={selectedImage} alt="Main Product" />
                    </div>
                </div>

                <div className="product-info">
                    <h2>{product.name}</h2>
                    <p className="price">
                        {product.price.toFixed(2)} dh
                        {product.originalPrice && (
                            <span className="original-price2">{product.originalPrice}</span>
                        )}
                    </p>
                    <p className="conseil">{product.description}</p>

                    {/* Characteristics Section */}
                    <div className="benefits-section">
                        <ul>
                            {product.characteristics.map((char, index) => (
                                <li key={index}>
                                    <img src={char.icon} alt={char.text} />
                                    <span>{char.text}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                    {!product.isPack && (
                        <>
                            <div className="quantity">
                                <label>Quantité</label>
                                <div className="quantity-selector">
                                    <button onClick={decreaseQuantity}>-</button>
                                    <input type="text" value={quantity} readOnly />
                                    <button onClick={increaseQuantity}>+</button>
                                </div>
                            </div>
                            <p className="stock-info">Il reste environ {stock !== null ? stock : '...'} articles.</p>
                        </>
                    )}
                    <button className="add-to-cart" onClick={handleAddToCart}>
                        Ajouter au panier
                    </button>
                </div>
            </div>
            {/* Product Description Section */}
            <h4 className="desc-title">{product.descriptionTitle}</h4>

            <div className="product-description">
                <div className="description-list">
                    {product.descriptionList.map((desc, index) => (
                        <div className="description-item" key={index}>
                            <span className="description-number">{desc.number}</span>
                            <div className="description-content">
                                <h5>{desc.title}</h5>
                                <p>{desc.text}</p>
                            </div>
                        </div>
                    ))}
                </div>
                <div className="description-image">
                    <img src={product.descriptionImage} alt="Ingredients visualization" />
                </div>
            </div>
            {/* Reviews Section */}
            {/* <div className="reviews-section">
                <h3>Avis des Clients</h3>
                {product.reviews && product.reviews.length > 0 ? (
                    product.reviews.map((review) => (
                        <div key={review.id} className="review">
                            <div className="review-stars">{"★".repeat(review.rating)}{"☆".repeat(5 - review.rating)}</div>
                            <p className="review-text">"{review.text}"</p>
                            <p className="review-author">- {review.author}</p>
                        </div>
                    ))
                ) : (
                    <p className="no-reviews">Aucun avis pour ce produit.</p>
                )}
            </div> */}
            
                {product.reviews && product.reviews.length > 0 &&

            <div className="reviews-section">
                <h3>Avis des Clients</h3>
                    {product.reviews.map((review) => (
                        <div key={review.id} className="review">
                            <div className="review-stars">{"★".repeat(review.rating)}{"☆".repeat(5 - review.rating)}</div>
                            <p className="review-text">"{review.text}"</p>
                            <p className="review-author">- {review.author}</p>
                        </div>
                    ))}
                
            </div> 
                }

        </div>
    );
};

export default ProductDetails;
